import { useAuth0 } from "@auth0/auth0-react";
import { FormatStrikethrough } from "@material-ui/icons";
import FinanceService from "Lib/API/Finance";
import FinanceSettingService from "Lib/API/FinanceSetting/FinanceSetting";
import axios from "axios";
import AlertDialog from "components/Dialog";
import SearchDownShift from "components/downmshift/DownShift";
import InfoTooltip from "components/InfoTooltip";
import { getCurrency } from "helper/numberFormat";
import { useSearch } from "hook";
import { debounce } from "lodash";
import { PriceType } from "pages/NewFinance/NewCharge/ChargeType/PercentageFixed";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { toastr } from "react-redux-toastr";
import { Link, useHistory } from "react-router-dom";
import Select, { components } from "react-select";
import BottomArrowSvg from "../../../../../src/assets/icons/svg/BottomArrowSvg";
import { InputField, LabelField, MyCheckbox } from "../../../../components";
import "./styles.scss";

const DropdownIndicator = (props) => {
  return (
    <components.DropdownIndicator {...props}>
      <BottomArrowSvg label="Emoji" />
    </components.DropdownIndicator>
  );
};
const NewLedgerAccounts = ({
  edit,
  formik,
  type,
  addNew,
  updateFunc,
  ledgerNameList,
  createFunc,
  disable,
  addPath,
  showNameChangeConfirm,
  setShowNameChangeConfirm,
  onConfirmNameChange,
  ledgerSubLedgerData,
}) => {
  const { push } = useHistory();
  const quicBookNameRef = useRef(null);
  const quicBookClassesNameRef = useRef(null);

  useEffect(() => {
    if (disable === false) {
      push({
        pathname: "/financial-setting/ledger-accounts/view",
      });
    }
  });

  const localStorageData = localStorage.getItem("organization")
    ? JSON.parse(localStorage.getItem("organization"))
    : null;
  const { getAccessTokenSilently } = useAuth0();
  const [loading, setLoading] = React.useState(false);
  const [gatewayFee, setGatewayFee] = useState("%");
  const [amountInput, setAmountInput] = useState("");

  const handleAddAmount = () => {
    const num = parseFloat(amountInput);
    if (!num || num <= 0) return;
    if (num > 99999) return toastr.info('Validation', 'Amount cannot exceed 99,999');
    const current = formik.values?.checkoutAmounts ?? [];
    if (!current.includes(num)) {
      formik.setFieldValue("checkoutAmounts", [...current, num]);
    }
    setAmountInput("");
  };

  const handleRemoveAmount = (val) => {
    formik.setFieldValue(
      "checkoutAmounts",
      (formik.values?.checkoutAmounts ?? []).filter((a) => a !== val)
    );
  };
  const [taxType, setTaxType] = useState("%");
  const [search, setSearch] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const [receivableAccounts, setReceivableAccounts] = useState([]);
  const [getQuickBooksLoading, setGetQuickBooksLoading] = useState(false);
  const [selectedReceivableAccount, setSelectedReceivableAccount] = useState(
    []
  );
  const currency = getCurrency();

  const [selectedQuery, setSelectedQuery] = useState({
    Id: formik?.values?.quickBooks_id ?? "",
    Name: formik?.values?.quickBooks_name ?? "",
  });

  const [selectedQueryClass, setSelectedQueryClass] = useState({
    Id: formik?.values?.quickBooksClass_id ?? "",
    Name: formik?.values?.quickBooksClass_name ?? "",
  });

  useEffect(() => {
    if (addNew) {
      setSelectedQuery({
        Id: "",
        Name: "",
      });
      setSelectedQueryClass({
        Id: "",
        Name: "",
      });
      setSelectedReceivableAccount({
        ar_id: "",
        ar_name: "",
      });
    }
  }, [addNew]);

  const { searchAction } = useSearch({ action: setSearch });
  const [openDisableAlert, setOpenDisableAlert] = useState(false);

  const option2 = receivableAccounts?.map((item, index) => ({
    value: item?._id,
    label: item?.ar_name ?? item?.ar_name,
  }));

  const AccountReceivableChange = (value) => {
    setSelectedReceivableAccount({
      ar_id: value.value,
      ar_name: value.label,
    });
    formik.setFieldValue(`account_receivable`, value.value);
  };

  const handleQueryArray = (value) => {
    setSelectedQuery({
      Id: value.value,
      Name: value.label,
    });
    formik.setFieldValue(`quickBooks_name`, value.label);
    formik.setFieldValue(`quickBooks_id`, value.value);
  };

  const handleQueryArrayClass = (value) => {
    setSelectedQueryClass({
      Id: value.value,
      Name: value.label,
    });
    formik.setFieldValue(`quickBooksClass_name`, value.label);
    formik.setFieldValue(`quickBooksClass_id`, value.value);
  };

  const handleCloseDialog = () => {
    setOpenDisableAlert(false);
  };
  const handleCancel = (e) => {
    setOpenDisableAlert(false);
    e.preventDefault();
    push({
      pathname: addPath.replace("edit", "view"),
    });
  };
  const cancelFunc = () => {
    setOpenDisableAlert(true);
  };
  const selectControlStyles = {
    backgroundColor: "#F3F6F9",
    borderColor: "#F3F6F9",
    color: "#3F4254",
    transition:
      "color 0.15s ease, background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease",
    paddingTop: "6px",
    paddingBottom: "6px",
    cursor: "pointer",
  };
  const colourStyles = {
    control: (styles) => ({
      ...styles,
      ...selectControlStyles,
    }),
  };
  const options =
    ledgerNameList &&
    ledgerNameList?.map((item) => {
      return {
        label: item?.ledger_name,
        value: item?._id,
      };
    });
  const preventMinus = (e) => {
    const characterCode = e.key;
    if (characterCode === "Backspace") return;

    const characterNumber = Number(characterCode);
    if (characterNumber >= 0 && characterNumber <= 9) {
      if (e.currentTarget.value && e.currentTarget.value.length) {
        return;
      } else if (characterNumber === 0) {
        e.preventDefault();
      }
    } else {
      e.preventDefault();
    }
  };
  const formatOptionLabel = ({ label, _id }) => {
    return (
      <div className="dropdown-container" key={_id}>
        <div className="icon-name-container d-flex align-items-center justify-content-start">
          <div className="name-container" style={{ marginInlineStart: 10 }}>
            <div>{label}</div>
          </div>
        </div>
      </div>
    );
  };
  const validateCreateFunc = () => {
    if (formik.values?.ledger_name === "") {
      return toastr.info("Validation", "Please fill the name field");
    }
    if (!formik.values?.ledger_checkbox) {
      if (formik.values?.ledgerId === "") {
        return toastr.info("Validation", "Please select the parent ledger ");
      }
    }
    createFunc();
    // formik.setFieldValue("ledger_name", "");
  };
  const exceptThisSymbols = ["e", "E", "+", "-"];

  const preventArrows = (e) => {
    if (e.which === 38 || e.which === 40 || exceptThisSymbols.includes(e.key))
      e.preventDefault();
  };
  const regex = /([0-9]*[\.|\,]{0,1}[0-9]{0,2})/s;

  const getReceivableAccounts = async () => {
    const token = await getAccessTokenSilently();
    await FinanceSettingService.getAllAccountReceivable(token)
      .then((res) => {
        setReceivableAccounts(res?.result);
      })
      .catch((e) => {
        toastr.error(e?.data?.message ?? "Error");
      });
  };

  // useEffect(() => {
  //   if (localStorageData?.quickBooks_information?.classes === true)
  //   getClassListForQB();
  // },[localStorageData])

  const getQuickBooksURL = async (row) => {
    setGetQuickBooksLoading(true)
    const token = await getAccessTokenSilently();
    await FinanceService.GetDepositQuickbooks(token).then((res) => {
      if (res?.result?.authenticated === true) {
        // createNewDeposit(row);
        getAccountListForQB();
        if (localStorageData?.quickBooks_information?.classes === true)
          getClassListForQB();
      } else {
        setGetQuickBooksLoading(false);
        window.open(
          res?.result?.url,
          "_blank",
          "toolbar=0,location=0,menubar=0"
        );
        // push({
        //   pathname: "/financial-setting",
        // });
      }
    })
    .catch((e) => {
      setGetQuickBooksLoading(false);
      toastr.error("Error", e?.data?.message ?? "Error");
    });
  };
  const [queryResponse, setQueryResponse] = useState([]);
  const [queryResponseClass, setQueryResponseClass] = useState([]);
  const getAccountListForQB = async () => {
    const token = await getAccessTokenSilently();
    await FinanceSettingService.GetListOfAccountForQB("Other Income", token)
      .then((res) => {
        const data = res?.result?.QueryResponse?.Account?.map(
          (item, index) => ({
            value: item?.Id,
            label: item?.Name,
          })
        );
        setQueryResponse(data);
        // setReceivableAccounts(res?.result);
      })
      .catch((e) => {
        toastr.error(e?.data?.message ?? "Error");
      })
      .finally(() => {
        setTimeout(() => {
          setGetQuickBooksLoading(false);
        }, 1000);
      });
  };

  const getClassListForQB = async () => {
    const token = await getAccessTokenSilently();
    await FinanceSettingService.GetListOfClassForQB("Other Income", token)
      .then((res) => {
        const data = res?.result?.QueryResponse?.Class?.map((item, index) => ({
          value: item?.Id,
          label: item?.Name,
        }));
        setQueryResponseClass(data);
        // setReceivableAccounts(res?.result);
      })
      .catch((e) => {
        toastr.error(e?.data?.message ?? "Error");
      })
      .finally(() => {
        setTimeout(() => {
          setGetQuickBooksLoading(false);
        }, 1000);
      });
  };

  useEffect(() => {
    getReceivableAccounts();
    // getAccountListForQB();
  }, []);

  const getReceivableAccountsByID = async (type, id) => {
    const token = await getAccessTokenSilently();
    await FinanceSettingService.getReceivableAccountsByID(
      token,
      formik?.values?.account_receivable
    )
      .then((res) => {
        setSelectedReceivableAccount({
          ar_id: res?.result?._id,
          ar_name: res?.result?.ar_name,
        });
      })
      .catch((e) => {
        // toastr.error("Error");
      });
  };

  useEffect(() => {
    if(!formik?.values?.account_receivable || addNew) return;
    getReceivableAccountsByID();
  }, [formik?.values?.account_receivable]);

  useEffect(() => {
    if (selectedReceivableAccount.length == 0) {
      setSelectedReceivableAccount({
        lable: option2?.find(
          (option) => option?.value == formik?.values?.account_receivable
        )?.label,
        value: option2?.find(
          (option) => option?.value == formik?.values?.account_receivable
        )?.value,
      });
    }
  }, [option2]);


  const onQuickBooksNameFocus = () => {
    if (
      localStorageData?.quickBooks_information?.program === "online") {
      getQuickBooksURL();
      quicBookNameRef.current.blur();
      quicBookClassesNameRef.current.blur();
    }
  }

  const isProgramSage = localStorageData?.quickBooks_information?.program === "sage";
  const isProgramOnline = localStorageData?.quickBooks_information?.program === "online";
  const isProgramDisable = localStorageData?.quickBooks_information?.program === "disable";
  
  return (
    <>
      <div className="actions-buttons p-5 pr-15">
        <div className="m-0" >
          <Link onClick={cancelFunc} className="btn btn-outline-primary leftmenu-btn">
            Cancel
          </Link>
        </div>
        <div className="m-0  payment-type-check-box">
          <Link
            className="btn btn-primary leftmenu-btn font-weight-bold ml-5"
            onClick={
              edit === true
                ? updateFunc
                : addNew === true
                  ? validateCreateFunc
                  : ""
            }
          // to={addPath.replace("edit", "view")}
          >
            Save Ledger
          </Link>
        </div>
      </div>
      <div className="col-sm-5 pl-5 ml-8  new-ledger-accounts">
        <InputField
          {...{
            formik,
            name: "ledger_name",
            placeholder: "Ledger Account Name",
          }}
          value={formik.values?.ledger_name}
          style={{
            height: "48px",
            backgroundColor: "#F3F6F9",
          }}
        />
      </div>
      <div className="d-flex pl-5 ml-5  pt-5 mt-5">
        {formik.values?.ledger_checkbox === true ? (
          ""
        ) : (
          <div className="col-sm-5">
            <div
              className={
                edit === true
                  ? "form-group disabled-action parentLedger-field"
                  : "form-group parentLedger-field"
              }
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                <LabelField title={"Parent Ledger"} />
                <InfoTooltip text="Nests this account under a parent ledger for hierarchical reporting. Only shown when this account isn't itself marked as a top-level Ledger below." style={{ marginLeft: '6px', marginBottom: '8px' }} />
              </div>
              <Select
                {...{
                  formik,
                  name: `ledgerId`,
                  checkValidation: false,
                }}
                onInputChange={(text) => searchAction(text)}
                classNamePrefix="react-select"
                formatOptionLabel={formatOptionLabel}
                options={options}
                isLoading={loading}
                styles={colourStyles}
                onChange={(value) => {
                  formik.setFieldValue(`ledgerId`, {
                    id: value.value,
                    name: value.label,
                  });
                }}
                defaultValue={
                  edit === true && formik.values?.ledgerId
                    ? {
                      label: formik.values?.parent_ledger,
                      value: formik.values?.ledgerforId,
                    }
                    : addNew === true && formik.values?.ledgerId
                      ? {
                        label:
                          formik?.values?.ledgerId?.name ??
                          formik.values?.parent_ledger,
                        value:
                          formik.values?.ledgerId?.id ??
                          formik.values?.ledgerforId,
                      }
                      : ""
                }
                components={{ DropdownIndicator }}
              />
            </div>
          </div>
        )}

        <div className="col-sm-5">
          <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
            <LabelField title={"Default Amount"} />
            <InfoTooltip text="Pre-fills the charge/payment amount whenever this ledger is selected elsewhere in the app." style={{ marginLeft: '6px', marginBottom: '8px' }} />
          </div>
          <InputField
            type="number"
            {...{
              formik,
              name: "default_amount",
              title: "none",
              placeholder: "Amount",
            }}
            formStyle={{ marginBottom: 0 }}
            onKeyDown={(e) => preventArrows(e)}
            // onKeyDown={preventMinus}
            min="0"
            handleChange={(e) => {
              formik.setFieldValue(
                `default_amount`,
                e.target.value.match(regex)[0]
              );
            }}
            value={formik.values?.default_amount}
            style={{ height: "48px" }}
          />
        </div>
      </div>
      <div className="d-flex pl-5 ml-5  pt-5">
        <div className="col-sm-5 setting-field">
          <LabelField title={"Account Receivable"} />
          <Select
            {...{
              formik,
              name: `account_receivable`,
              checkValidation: false,
            }}
            onInputChange={(text) => searchAction(text)}
            classNamePrefix="react-select"
            formatOptionLabel={formatOptionLabel}
            options={option2}
            isLoading={loading}
            styles={colourStyles}
            onChange={(value) => AccountReceivableChange(value)}
            value={
              selectedReceivableAccount
                ? {
                  label: selectedReceivableAccount?.ar_name,
                  value: selectedReceivableAccount?.ar_id,
                }
                : ""
            }
            components={{ DropdownIndicator }}
            isDisabled={false}
          />
        </div>
      </div>

      <div className="d-flex pl-5 ml-5  pt-5">
        {(!isProgramDisable) && (
          <div className="col-sm-5 setting-field">
            {(queryResponse?.length > 0 || getQuickBooksLoading) ? (
              <>
                <LabelField title={"QuickBooks Account"} />

                <Select
                  {...{
                    formik,
                    name: `account_receivable`,
                    checkValidation: false,
                  }}
                  onInputChange={(text) => searchAction(text)}
                  classNamePrefix="react-select"
                  formatOptionLabel={formatOptionLabel}
                  options={queryResponse}
                  isLoading={loading || getQuickBooksLoading}
                  styles={colourStyles}
                  onChange={(value) => handleQueryArray(value)}
                  value={
                    selectedQuery
                      ? {
                        label: selectedQuery?.Name,
                        value: selectedQuery?.Id,
                      }
                      : ""
                  }
                  components={{ DropdownIndicator }}
                  isDisabled={false}
                />
              </>
            ) : (
              <InputField
                mandatory={true}
                {...{
                  formik,
                  title: isProgramSage ? "Sage Name" : "QuickBooks Name",
                  name: "quickBooks_name",
                  placeholder: isProgramSage ? "Sage Name" : "QuickBooks Name",
                }}
                value={formik.values?.quickBooks_name}
                style={{
                  height: "48px",
                  backgroundColor: "#F3F6F9",
                }}
                onFocus={onQuickBooksNameFocus}
                inputRef={quicBookNameRef}
              />
            )}
          </div>
        )}

        {(isProgramOnline || isProgramSage) && (
          <div className="col-sm-5 setting-field">
            <InputField
              mandatory={true}
              {...{
                formik,
                title: isProgramSage ? "Sage ID" : "QuickBooks ID",
                name: "quickBooks_id",
                placeholder: isProgramSage ? "Sage ID" : "QuickBooks ID",
              }}
              // isDisabled
              disabled={isProgramSage ? false : true}
              value={formik.values?.quickBooks_id}
              style={{
                height: "48px",
                backgroundColor: "#F3F6F9",
              }}
            />
          </div>
        )}
      </div>

      {localStorageData?.quickBooks_information?.classes === true ? (
        <div className="d-flex pl-5 ml-5  pt-5">
          <div className="col-sm-5 setting-field">
            {(queryResponseClass?.length > 0 || getQuickBooksLoading) ? (
              <>
                <LabelField title={"QuickBooks Class Name"} hint="Maps this ledger to a QuickBooks 'Class' for cross-departmental reporting." />

                <Select
                  {...{
                    formik,
                    name: `account_receivable`,
                    checkValidation: false,
                  }}
                  onInputChange={(text) => searchAction(text)}
                  classNamePrefix="react-select"
                  formatOptionLabel={formatOptionLabel}
                  options={queryResponseClass}
                  isLoading={loading || getQuickBooksLoading}
                  styles={colourStyles}
                  onChange={(value) => handleQueryArrayClass(value)}
                  value={
                    selectedQueryClass
                      ? {
                        label: selectedQueryClass?.Name,
                        value: selectedQueryClass?.Id,
                      }
                      : ""
                  }
                  components={{ DropdownIndicator }}
                  isDisabled={false}
                />
              </>
            ) : (
              <>
                <LabelField title={"QuickBooks Class Name"} mandatory hint="Maps this ledger to a QuickBooks 'Class' for cross-departmental reporting." />
                <InputField
                  {...{
                    formik,
                    title: "none",
                    name: "quickBooksClass_name",
                    placeholder: "QuickBooks Class Name",
                  }}
                  formStyle={{ marginBottom: 0 }}
                  value={formik.values?.quickBooksClass_name}
                  style={{
                    height: "48px",
                    backgroundColor: "#F3F6F9",
                  }}
                  onFocus={onQuickBooksNameFocus}
                  inputRef={quicBookClassesNameRef}
                />
              </>
            )}
          </div>
        {localStorageData?.quickBooks_information?.program === "online" && (
          <div className="col-sm-5 setting-field">
            <InputField
              mandatory={true}
              {...{
                formik,
                title: "QuickBooks class ID",
                name: "quickBooksClass_id",
                placeholder: "QuickBooks Class ID",
              }}
              // isDisabled
              disabled={true}
              value={formik.values?.quickBooksClass_id}
              style={{
                height: "48px",
                backgroundColor: "#F3F6F9",
              }}
            />
          </div>
        )}
        </div>
      ) : (
        <div></div>
      )}

      <div className="billing-amount-details charge-type-fields mt-10">
        <div className="col-md-5 d-flex align-items-center ml-10">
          <div className="">
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
              <LabelField title={"Tax Deductible"} />
              <InfoTooltip text="Sets how much of a payment to this ledger counts as tax-deductible, as an amount or percentage. Used for donation-receipt calculations." style={{ marginLeft: '6px', marginBottom: '8px' }} />
            </div>
            <InputField
              type="number"
              {...{
                formik,
                title: "none",
                name: `amount_deductible`,
                placeholderIcon: (
                  <span className="placeholder-icon">
                    {taxType === "%" ? "%" : currency}
                  </span>
                ),
                placeholder: "Tax",
                checkValidation: true,
              }}
              formStyle={{ marginBottom: 0 }}
              onKeyDown={(e) => preventArrows(e)}
              style={{
                border: "none",
                backgroundColor: "#F3F6F9",
              }}
              handleChange={(e) => {
                const val = e.target.value.match(regex)[0];
                const maxVal = formik.values?.deductibleType === '%' ? 100 : 10000;
                if (parseFloat(val) > maxVal) return;
                formik.setFieldValue(`amount_deductible`, val);
              }}
              value={formik.values?.amount_deductible}
            />
          </div>
          <div className="price-type">
            <PriceType
              value={formik.values?.deductibleType}
              handleClick={setTaxType}
              setFieldValue={formik.setFieldValue}
              type="deductibleType"
              discount="amount_deductible"
            />
            {/* </div> */}
          </div>
        </div>
        {/* <div className="col-md-5 pr-0 pl-0 d-flex align-items-center ledger-gateway">
          <div className="">
            <InputField
              type="number"
              {...{
                formik,
                title: "Gateway Fee Override",
                name: `gateway_fee_override`,
                placeholderIcon: (
                  <span className="placeholder-icon">
                    {gatewayFee === "%" ? "%" : "$"}
                  </span>
                ),
                placeholder: "Tax",
                checkValidation: true,
              }}
              onKeyDown={(e) => preventArrows(e)}
              style={{
                border: "none",
                backgroundColor: "#F3F6F9",
              }}
              handleChange={(e) => {
                formik.setFieldValue(
                  `gateway_fee_override`,
                  e.target.value.match(regex)[0]
                );
              }}
              value={formik.values?.gateway_fee_override}
            />
          </div>
          <div className="price-type">
            <PriceType
              value={formik.values?.feeType}
              handleClick={setGatewayFee}
              setFieldValue={formik.setFieldValue}
              type="feeType"
            />
          </div>
        </div> */}
      </div>
      <div className="d-flex ml-15 pt-5 mt-5">
        {addNew === true || edit === true ? (
          <div className="m-0 payment-type-check-box pr-5 mr-5" style={{ display: 'flex', alignItems: 'center' }}>
            <MyCheckbox
              name={`ledger_checkbox`}
              title="Ledger"
              handlechange={(event) => {
                formik.setFieldValue("ledger_checkbox", event.target.checked);
              }}
              checked={formik.values?.ledger_checkbox ?? "false"}
              value={formik.values?.ledger_checkbox ?? "false"}
            />
            <InfoTooltip text="Marks this as a standalone top-level ledger rather than a sub-ledger. Toggling this changes whether Parent Ledger is required." style={{ marginLeft: '6px', marginBottom: '8px' }} />
          </div>
        ) : disable ? (
          <div className="m-0 disabled-action payment-type-check-box pr-5 mr-5" style={{ display: 'flex', alignItems: 'center' }}>
            <MyCheckbox
              name={`ledger_checkbox`}
              title="Ledger"
              handlechange={(event) => {
                formik.setFieldValue("ledger_checkbox", event.target.checked);
              }}
            />
            <InfoTooltip text="Marks this as a standalone top-level ledger rather than a sub-ledger. Toggling this changes whether Parent Ledger is required." style={{ marginLeft: '6px', marginBottom: '8px' }} />
          </div>
        ) : (
          ""
        )}

        <div className="m-0 ledger-check-box payment-type-check-box pr-5 mr-5" style={{ display: 'flex', alignItems: 'center' }}>
          <MyCheckbox
            name={`donation`}
            title="Donation"
            handlechange={(event) => {
              formik.setFieldValue("donation", event.target.checked);
            }}
            checked={formik.values?.donation ?? "true"}
            value={formik.values?.donation ?? "false"}
          />
          <InfoTooltip text="Flags this ledger as donation-eligible so it appears in donation pickers and receipts elsewhere in the app." style={{ marginLeft: '6px', marginBottom: '8px' }} />
        </div>

        <div className="m-0  payment-type-check-box pl-5 ml-5" style={{ display: 'flex', alignItems: 'center' }}>
          <MyCheckbox
            name={`require_notes`}
            title="Require Notes"
            handlechange={(event) => {
              formik.setFieldValue("require_notes", event.target.checked);
            }}
            checked={formik.values?.require_notes ?? "false"}
            value={formik.values?.require_notes ?? "false"}
          />
          <InfoTooltip text="Forces a note to be entered whenever a transaction is posted to this ledger." style={{ marginLeft: '6px', marginBottom: '8px' }} />
        </div>
        <div className="m-0  payment-type-check-box pl-5 ml-5" style={{ display: 'flex', alignItems: 'center' }}>
          <MyCheckbox
            name={`archived`}
            title="Archived"
            handlechange={(event) => {
              formik.setFieldValue("archived", event.target.checked);
            }}
            checked={formik.values?.archived ?? "false"}
            value={formik.values?.archived ?? "false"}
          />
          <InfoTooltip text="Hides this ledger from active selection lists without deleting its historical data." style={{ marginLeft: '6px', marginBottom: '8px' }} />
        </div>
        <div className="m-0  payment-type-check-box pl-5 ml-5" style={{ display: 'flex', alignItems: 'center' }}>
          <MyCheckbox
            name={`defaultCOA`}
            title="Default for COA"
            handlechange={(event) => {
              formik.setFieldValue("defaultCOA", event.target.checked);
            }}
            checked={formik.values?.defaultCOA ?? "false"}
            value={formik.values?.defaultCOA ?? "false"}
          />
          <InfoTooltip text="Marks this as the default account for its Chart-of-Accounts category, used when no specific ledger is chosen." style={{ marginLeft: '6px', marginBottom: '8px' }} />
        </div>

      </div>

      <div className="d-flex ml-15 pt-3">
        <div className="m-0 payment-type-check-box" style={{ display: 'flex', alignItems: 'center' }}>
          <MyCheckbox
            name={`showOnCheckout`}
            title="Show on checkout"
            handlechange={(event) => {
              formik.setFieldValue("showOnCheckout", event.target.checked);
              if (!event.target.checked) {
                formik.setFieldValue("checkoutLabel", "");
                formik.setFieldValue("checkoutAmounts", []);
                formik.setFieldValue("checkoutAllowOther", false);
              }
            }}
            checked={formik.values?.showOnCheckout ?? false}
            value={formik.values?.showOnCheckout ?? false}
          />
          <InfoTooltip text="Shows this ledger as a selectable donation/add-on option on the public checkout page. Turning it off clears the checkout title, label, and amounts below." style={{ marginLeft: '6px', marginBottom: '8px' }} />
        </div>
      </div>

      {formik.values?.showOnCheckout && (
        <div className="pl-5 ml-5 mt-5 col-sm-8">
          <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
            <LabelField title={"Title"} mandatory />
            <InfoTooltip text="Configures the public checkout widget for this ledger: the heading text, the prompt text, preset suggested amounts, and whether the payer can type a custom amount." style={{ marginLeft: '6px', marginBottom: '8px' }} />
          </div>
          <InputField
            {...{ formik, name: "checkoutTitle", title: "none", placeholder: "e.g. Support our community", mandatory: true }}
            formStyle={{ marginBottom: 0 }}
            value={formik.values?.checkoutTitle}
            maxLength={50}
            style={{ height: "48px", backgroundColor: "#F3F6F9" }}
          />
          <InputField
            {...{ formik, name: "checkoutLabel", title: "Label", placeholder: "e.g. Would you like to add a donation?", mandatory: true }}
            value={formik.values?.checkoutLabel}
            maxLength={50}
            style={{ height: "48px", backgroundColor: "#F3F6F9" }}
          />
          <div className="mt-4">
            <LabelField title={"Amounts"} />
            <div className="d-flex align-items-center mt-2">
              <input
                type="number"
                className="form-control"
                style={{ width: 120, height: 48, backgroundColor: "#F3F6F9", border: "none" }}
                value={amountInput}
                min="0"
                max="99999"
                placeholder="Amount"
                onChange={(e) => { if (e.target.value.length <= 5) setAmountInput(e.target.value); }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") { e.preventDefault(); handleAddAmount(); }
                  if (exceptThisSymbols.includes(e.key)) e.preventDefault();
                }}
              />
              <button type="button" className="btn btn-primary ml-3" onClick={handleAddAmount}>Add</button>
            </div>
            <div className="d-flex flex-wrap mt-2">
              {(formik.values?.checkoutAmounts ?? []).map((amt) => (
                <span key={amt} style={{ display: "inline-flex", alignItems: "center", backgroundColor: "#3699FF", color: "#fff", padding: "4px 10px", borderRadius: "4px", fontSize: "13px", marginRight: "8px", marginTop: "8px" }}>
                  {currency}{amt}
                  <span style={{ cursor: "pointer", marginLeft: "6px", fontWeight: "bold" }} onClick={() => handleRemoveAmount(amt)}>×</span>
                </span>
              ))}
            </div>
          </div>
          <div className="mt-4">
            <MyCheckbox
              name={`checkoutAllowOther`}
              title="Allow other"
              handlechange={(event) => formik.setFieldValue("checkoutAllowOther", event.target.checked)}
              checked={formik.values?.checkoutAllowOther ?? false}
              value={formik.values?.checkoutAllowOther ?? false}
            />
          </div>
        </div>
      )}

      <AlertDialog
        open={openDisableAlert}
        handleClose={handleCloseDialog}
        onDecline={() => {
          setOpenDisableAlert(false);
        }}
        onAccept={handleCancel}
        title={" Are you sure?"}
        description={"Do you want to discard the changes you made?"}
      />

      <AlertDialog
        open={!!showNameChangeConfirm}
        onDecline={() => setShowNameChangeConfirm(false)}
        onAccept={() => {
          setShowNameChangeConfirm(false);
          onConfirmNameChange();
        }}
        title={"Update Ledger Name"}
        acceptBtnText={"Update"}
        description={
          <div style={{ textAlign: 'left' }}>
            <p style={{ marginBottom: '8px' }}>By clicking update you are aware and agree to the below:</p>
            <ul style={{ paddingLeft: '18px', marginBottom: 0 }}>
              <li style={{ marginBottom: '6px' }}>All related transaction and documents will be updated with the new ledger name.</li>
              <li>Your accounting software (if connected) will not be updated. In order to keep the data accurate, you will need to update it manually.</li>
            </ul>
          </div>
        }
      />
    </>
  );
};

export default NewLedgerAccounts;
